
import bg2 from '../imgs/bg2webP.webp'
import elec from '../imgs/electric.jpg'
import elecwebP from '../imgs/electric.webp'
import park from '../imgs/park.jpg'
import parkwebP from '../imgs/park.webp'
import util from '../imgs/util.jpg'
import utilwebP from '../imgs/util.webp'
import { motion } from 'framer-motion'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

const About = () => {

    useEffect(()=>{
        window.scrollTo(0, 0);
      },[])

    return (
        <div id="about" className="main" style= {{ backgroundImage: `url(${ bg2 })`}} >
            <motion.div className="content"
                            initial={ {opacity: 0 } }
                            animate={ {opacity: 1} }
                            transition={{
                                ease: "easeInOut",
                                duration: 0.2
                            }}
                            exit={ {
                                opacity: 0, 
                                filter: "blur(20px)"
                                } }
                >

                <h1> RV Sites </h1>
    
                    <span>We currently have 7 RV unit sites. Each site has:</span>
                        
                        <ul>
                            <li>
                            Water and sewer hookups
                            </li>
                            <li>
                                50/30/20 amp electrical service
                            </li>
                            <li>
                                Each site is 15' x 58'
                            </li>
                            <li>
                                Gravel roads and driveways to make parking easy and convenient
                            </li>
                        </ul>

                    <br />

                    <picture>
                    <source srcSet= { parkwebP } type ="image/webp" />
                    <img src= { park } alt="decorative" />
                </picture>
                <br/>
                
                <picture >
                    <source srcSet= { utilwebP } type ="image/webp" className='infopic' />
                    <img src= { util } alt="decorative" className='infopic' />
                </picture>

                <br />

                <picture >
                    <source srcSet= { elecwebP } type ="image/webp" className='infopic' />
                    <img src= { elec } alt="decorative" className='infopic' />
                </picture>

                <br />

                    <h2>Overnight Stays</h2>
                        <span>
                            <Link to="/contact">Contact Us for pricing</Link>
                        </span>
                        <br />
                        <span>
                            We offer daily rates on 30 amp and 50 amp sites. 
                            Choose between electric-only or full service sites (electric, water, and sewer hook-ups). 
                            Electric-only sites have water source and sewer dump available for use on the property.
                            Option to add on high-speed fiber internet.
                        </span>
                        <br />



<h2>Long-Term Stays</h2>
                    <span>
                        <Link to="/contact">Contact Us for pricing</Link>
                    </span>
                    <br/>
                    <span>
                        Weekly & Monthly rates for 30 amp or 50 amp include all hookups (water, electric, sewer) and trash disposal. 
                        Option to add on high-speed fiber internet.
                    </span>
                    
                    <br />
                    <br />

                    <h2>About Us</h2>
                    <span>
                        Our park is the ideal spot for traveling workers and long-term tenants alike, with grocery, restaurants, and laundry facilities a short 15 minute drive away. 
                        There's also an on-site bar within walking distance which offers food, cold beers, and karaoke and bon fires on Saturday nights. 
                        For further information, visit <a href="https://nirvanaroadhouse.com/" target="_blank" rel="noreferrer">Nirvana Roadhouse.</a>
                        
                        <br />
                        Nirvana RV Park provides a safe and quiet place to call home while being close enough to town to easily meet all your daily needs.
                        The park owner also lives on-site and is always available to assist with any needs or concerns.
                    </span>

                    
            </motion.div>
        </div>
    )

}

export default About